import { ModalManager } from "@/react/components/Layout/ModalManagerProvider";
import { type MarketingEmailTemplateContentType } from "@/react/types/MarketingEmailTemplates";
import { useBroadcastData } from "../../BroadcastDataContext";
import { REPLACE_CONFIRMATION_MODAL_ID } from "../ReplaceConfirmationModal";
import { useApplyTemplate } from "./useApplyTemplate";

export function useNavigateContentWithApplyTemplate() {
  const { data } = useBroadcastData();
  const { onApplyTemplate, isApplyingTemplate } = useApplyTemplate();

  const handleNavigateContentWithApplyTemplate = async (
    templateId: number,
    templateContentType: MarketingEmailTemplateContentType,
  ) => {
    const doesContentAlreadyExist = Boolean(
      data?.broadcast_content?.email_content ??
        data?.broadcast_content?.visual_email_builder_content,
    );
    if (doesContentAlreadyExist) {
      void ModalManager.show(REPLACE_CONFIRMATION_MODAL_ID, {
        templateId,
        templateContentType: templateContentType,
      });
      return;
    }

    await onApplyTemplate(templateId, templateContentType);
  };

  return {
    handleNavigateContentWithApplyTemplate,
    isApplyingTemplate,
  };
}
